var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52.3px",
    height: "63.89px",
    viewBox: "0 0 52.3 63.89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-273.190000, -3769.230000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(-0.060000, -1.890000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.55,3782.3 L325.55,3822.33 L299.4,3835.01 L273.25,3822.33 L273.25,3771.12 L299.4,3771.12 L299.4,3778.69 L280.82,3778.69 L280.82,3817.61 L299.4,3826.62 L317.99,3817.61 L317.99,3782.3 L325.55,3782.3 L325.55,3782.3 Z M316.19,3793.97 L296.76,3813.41 L285.8,3802.44 L291.15,3797.09 L296.76,3802.71 L310.84,3788.62 L316.19,3793.97 Z",
    id: "Path_39"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.1b3de9c2004ce011312adc1e6e6b75c1.svg";
export { ForwardRef as ReactComponent };